<template>
  <div class="ac-service-resolved ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-b gap-16">
        <button
          class="ac-close-button"
          type="button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="sac__font-24 semi-bold">
          {{ isComplete ? 'Complete' : 'Resolve' }}
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="grid-column even">
        <div class="ac-input-container">
          <div class="sac__font-18 med margin-bottom-12">
            Date Resolved:
          </div>
          <Datepicker
            field="resolvedDate"
            v-model="serviceDate"
            :max-date="new Date()"
          />
          <div
            v-if="errorObj.serviceDateErr"
            class="ac-input-error"
          >
            {{ errorObj.serviceDateErr }}
          </div>
        </div>
        <div class="ac-input-container">
          <div class="sac__font-18 med margin-bottom-12">
            Time Resolved:
          </div>
          <SACDropdown
            :options="confirmedTimeOp"
            :value="serviceTime"
            placeholder="Select Time"
            field="serviceTime"
            :change="change"
            :error="errorObj.serviceTimeErr"
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="grid-column ai-c jc-b">
          <div class="sac__font-18 med margin-bottom-4">
            Technician
            <span class="sac__font-12">(Optional):</span>
          </div>
          <!--          <button-->
          <!--            v-if="adminRole === 'admin'"-->
          <!--            class="sac__font-14 semi-bold f-primary"-->
          <!--            @click="addTechnician"-->
          <!--          >-->
          <!--            + Add technician-->
          <!--          </button>-->
        </div>
        <SACDropdown
          placeholder="Select Tech"
          searchParameter="label"
          field="assignedTechId"
          :options="getTechOptions(actionRequest.corpId)"
          :value="assignedTechId"
          :change="change"
        />
      </div>
      <div
        v-if="isComplete"
        class="ac-input-container margin-top-4"
      >
        <div class="sac__font-18 mb-2">
          Job Value
          <span class="sac__font-12">(Optional):</span>
        </div>
        <SACInput
          field="jobValue"
          type="number"
          placeholder="Enter $ estimate here.."
          :value="jobValue"
          :change="change"
        />
      </div>
      <div v-if="isComplete" class="ac-input-container">
        <div class="grid-column ai-c jc-e">
          <button
            type="button"
            class="grid-column ai-c sac__font-14 semi-bold f-primary"
            @click.prevent="triggerFileSelect"
          >
            {{ invoiceName }}
          </button>
          <button
            v-if="invoiceFileName"
            type="button"
            @click="deleteInvoice"
          >
            <img
              src="@shared/assets/img/general/svg/x-red.svg"
              alt="delete"
              class="img-size-20"
            />
          </button>
        </div>
        <input
          ref="invoiceFileInput"
          type="file"
          accept="application/pdf"
          style="display: none;"
          @change="handleFileSelect"
        />
      </div>
      <div class="ac-input-container">
        <div class="sac__font-18 med margin-bottom-12">
          Notes <span class="sac__font-12">(Optional)</span>
        </div>
        <textarea
          placeholder="Leave a note here.."
          :value="actionNote"
          @change="change('actionNote', $event.target.value)"
        />
        <div class="ac-input-footer-container">
          <div
            v-if="actionNote.length > 500"
            class="ac-input-error"
          >
            500 Character Max
          </div>
          <div
            class="sac__font-12 left"
          >
            500 Character Max
          </div>
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        type="button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        :disabled="processingAction || uploadingInvoice"
        type="button"
        @click="resolveService"
      >
        <img
          v-if="processingAction || uploadingInvoice"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span v-else>Submit</span>
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import serviceMixin from '@shared/mixins/serviceMixin';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ActionStatus from '@shared/lib/constant/ActionStatus';

export default {
  name: 'ServiceResolved',
  components: {
    SACDropdown,
    SACInput,
    Datepicker,
  },
  mixins: [serviceMixin],
  props: {
    isComplete: Boolean,
  },
  data() {
    return {
      invoiceFileName: null,
      invoiceFile: null,
      serviceTime: '',
      jobValue: null,
      actionNote: '',
      assignedTechId: 0,
      errorObj: {},
      serviceDate: new Date(),
    };
  },
  computed: {
    invoiceName() {
      if (!this.invoiceFileName) {
        return 'Upload Invoice';
      }
      return this.invoiceFileName;
    },
  },
  mounted() {
    this.getTechList();
  },
  methods: {
    async handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.invoiceFile = file;
        this.invoiceFileName = file.name;
        this.$refs.invoiceFileInput.value = null;
      }
    },
    triggerFileSelect() {
      this.$refs.invoiceFileInput.click();
    },
    deleteInvoice() {
      this.invoiceFile = null;
      this.invoiceFileName = null;
    },
    uploadInvoice() {
      const formData = new FormData();
      formData.append('pdfDoc', this.invoiceFile);
      formData.append('jobId', this.actionRequest.jobId);
      return this.$store.dispatch('setInvoice', formData);
    },
    isValid() {
      const temp = {};
      if (!this.serviceDate) {
        temp.serviceDateErr = 'Please select day';
      }
      if (!this.serviceTime) {
        temp.serviceTimeErr = 'Please select time';
      }
      this.errorObj = { ...temp };
      return Object.keys(this.errorObj).length === 0;
    },
    async resolveService() {
      if (this.isValid()) {
        const {
          alertNoticeId,
          jobId,
          requestId,
        } = this.actionRequest;
        const actionReq = {
          ...this.actionRequest,
          assignedTechId: this.assignedTechId,
          actionStatus: this.isComplete ? ActionStatus.Completed : ActionStatus.Resolved,
          serviceDate: this.serviceDate,
          actionNote: this.actionNote,
          serviceCost: this.jobValue,
          workPerformed: this.actionNote,
        };
        if (jobId) {
          if (this.invoiceFile) {
            actionReq.invoiceUrl = await this.uploadInvoice();
          }
          await this.$store.dispatch('updateServiceJob', actionReq);
        } else if (alertNoticeId) {
          await this.$store.dispatch('updateAlertNoticeAction', actionReq);
        } else if (requestId) {
          await this.$store.dispatch('updateServiceRequest', actionReq);
        }
        this.toggleActionModal(false);
      }
    },
    change(f, v) { this[f] = v; },
  },
};
</script>
